import { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { createDepartment } from "../../redux/apiCalls/departmentApiCalls";

const AddDepartmentForm = () => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");

  // From Submit Handler
  const formSubmitHandler = (e) => {
    e.preventDefault();
    if (title.trim() === "") return toast.error("department Title is required");
    dispatch(createDepartment({ title }));
    setTitle("");
  };

  return (
    <>
      <div className="add-department">
        <h6 className="add-department-title">اضافة قسم جديد</h6>
        <form onSubmit={formSubmitHandler} className="add-department-form">
          <div className="add-department-form-group">
            <label htmlFor="title">التخصص</label>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              type="text"
              id="title"
              placeholder="اضافة تخصص جديد"
            />
          </div>
          <button type="submit" className="add-department-btn">
            اضافة
          </button>
        </form>
      </div>
    </>
  );
};
export default AddDepartmentForm;
